import { useEffect } from "react";

const useLayoutHeight = (
  videoRefBg: React.RefObject<HTMLVideoElement>,
  isVideoLoading: boolean,
  videoLayoutHeight: number
) => {
  useEffect(() => {
    if (isVideoLoading) return;
    document.documentElement.style.setProperty(
      "--cardscan-video-background-height",
      videoLayoutHeight ? `${videoLayoutHeight}px` : "0"
    );

    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--cardscan-video-background-height",
        videoLayoutHeight ? `${videoLayoutHeight}px` : "0"
      );
    });
  }, [videoRefBg, isVideoLoading, videoLayoutHeight]);
};

export default useLayoutHeight;
